import React, { ReactElement } from "react";
import { Switch, SwitchProps } from "antd";
import "./index.less";

export type { SwitchProps as SettingSwitchProps } from "antd";

export const SettingSwitch: React.FC<SwitchProps> = ({ className, ...props }): ReactElement => {
    return (
        <Switch defaultChecked className={`Setting-Switch ${className}`} tabIndex={-1} {...props} />
    );
};
